import { useEffect, useCallback, useRef, useState } from "react";
import { toast } from "react-toastify";
import UserManagementActions from "../../Actions/UserManagementActions";
import UsermanagementConstants from "../../Constants/UsermanagementConstants";
import usermanagementStore from "../../Stores/UsermanagementStore";
import BlockOrganisation from "./BlockOrganisation";
import AddOrganizations from "./AddOrganizations";
import AddOrganizationAdmin from "./AddOrganizationAdmin";
import AddPlant from "./AddPlant";
import {
  MdAddBusiness,
  MdPersonAdd,
  MdAddLocationAlt,
  MdAddCircleOutline,
  MdDelete,
  MdDeleteOutline,
  MdDownloadForOffline,
  MdRefresh,
  MdError,
} from "react-icons/md";
import CircularProgress from "@mui/material/CircularProgress";
import { BiExport } from "react-icons/bi";
import { CgBlock, CgUnblock } from "react-icons/cg";
import { FaRegClone } from "react-icons/fa";
import { useGlobalSpinnerActionsContext } from "../../Context/GlobalSpinnerContext";
import { useLanguageContext } from "../../Context/LanguageContext";
import organisationSettingStore from "../../Stores/OrganisationSettingStore";
import organisationSettingConstants from "../../Constants/OrganisationSettingConstants";
import OrganisationSettingActions from "../../Actions/OrganisationSettingActions";
import ConfirmationPopUp from "../MessageBox/ConfirmationPopUp";
import plantStore from "../../Stores/PlantStores";
import PlantConstants from "../../Constants/PlantConstants";
import commonUtils from "../../helpers/commonUtils";
import CloneOrganisation from "../Clone-Organisation/CloneOrganisation";
var dateFormat = require("dateformat");

const OrganizationsAdmin = () => {
  const [confirmationPopUpOpen, setConfirmationPopUpOpen] = useState(false);
  const [confirmationPopUpMsg, setConfirmationPopUpMsg] = useState("");
  const [callbackData, setCallbackData] = useState(null);
  const [eventType, setEventType] = useState(null);
  const [organisationsList, setOrganizationList] = useState([]);
  const setGlobalSpinner = useGlobalSpinnerActionsContext();
  const [orgid, setOrgid] = useState(0);
  const [orgname, setOrgName] = useState("");
  const currentExportOrgName = useRef("");
  const isWebsiteAdmin = true;
  const { localization } = useLanguageContext();

  const getOrganisations = () => {
    setGlobalSpinner(true);
    UserManagementActions.getOrganisations();
  };

  const unblockOrganisation = (id) => {
    setGlobalSpinner(true);
    UserManagementActions.UnblockOrganisation(id);
  };

  useEffect(() => {
    getOrganisations();
    function getOrganisationSuccess() {
      var res = usermanagementStore.getOrganisatioList();
      if (res.length > 0) {
        setOrganizationList(res);
      } else {
        toast.error(localization.noOrganisationsExists);
      }
      setGlobalSpinner(false);
    }

    function getOrganisationFailure() {
      setGlobalSpinner(false);
    }

    function unblockOrganisationSuccess() {
      var res = usermanagementStore.getUnBlockOrganisationResult();
      if (res) {
        toast.success(localization.organisationUnBlockedSuccessfully);
        getOrganisations();
      }
    }

    function unblockOrganisationFailure() {
      var res = usermanagementStore.getUnBlockOrganisationResult();
      if (res) {
        toast.error(res);
      }
      setGlobalSpinner(false);
    }

    usermanagementStore.addChangeListener(
      UsermanagementConstants.GET_ORGANISATION_SUCCESS,
      getOrganisationSuccess,
    );

    usermanagementStore.addChangeListener(
      UsermanagementConstants.GET_ORGANISATION_FAILURE,
      getOrganisationFailure,
    );

    usermanagementStore.addChangeListener(
      UsermanagementConstants.UNBLOCK_ORGANISATION_SUCCESS,
      unblockOrganisationSuccess,
    );

    usermanagementStore.addChangeListener(
      UsermanagementConstants.UNBLOCK_ORGANISATION_FAILURE,
      unblockOrganisationFailure,
    );

    return () => {
      usermanagementStore.removeChangeListener(
        UsermanagementConstants.GET_ORGANISATION_SUCCESS,
        getOrganisationSuccess,
      );

      usermanagementStore.removeChangeListener(
        UsermanagementConstants.GET_ORGANISATION_FAILURE,
        getOrganisationFailure,
      );

      usermanagementStore.removeChangeListener(
        UsermanagementConstants.UNBLOCK_ORGANISATION_SUCCESS,
        unblockOrganisationSuccess,
      );

      usermanagementStore.removeChangeListener(
        UsermanagementConstants.UNBLOCK_ORGANISATION_FAILURE,
        unblockOrganisationFailure,
      );
    };
  }, [setOrganizationList]);

  /*------------------------------Add organisation section start ------------------------------------*/
  useEffect(() => {
    function addOrganisationSuccess() {
      var res = usermanagementStore.getAddOrUpdateOrganisationResult();
      if (res) {
        commonUtils.hideModalPopUp("addOrganisationModalClose");
        toast.success(localization.orgAddedSuccessfully);
        getOrganisations();
      }
    }

    function addOrganisationFailure() {
      var res = usermanagementStore.getAddOrUpdateOrganisationResult();
      toast.error(res);
      setGlobalSpinner(false);
    }

    usermanagementStore.addChangeListener(
      UsermanagementConstants.ADDORUPDATE_ORGANISATION_SUCCESS,
      addOrganisationSuccess,
    );

    usermanagementStore.addChangeListener(
      UsermanagementConstants.ADDORUPDATE_ORGANISATION_FAILURE,
      addOrganisationFailure,
    );

    return () => {
      usermanagementStore.removeChangeListener(
        UsermanagementConstants.ADDORUPDATE_ORGANISATION_SUCCESS,
        addOrganisationSuccess,
      );

      usermanagementStore.removeChangeListener(
        UsermanagementConstants.ADDORUPDATE_ORGANISATION_FAILURE,
        addOrganisationFailure,
      );
    };
  }, []);
  /*-----------------------------Add organisation section end ---------------------------------------*/

  /*----------------------------Add plant section start ----------------------------------------------*/
  useEffect(() => {
    function addPlantSuccess() {
      const res = plantStore.getAddPlantWebAdminResult();
      if (res) {
        toast.success(localization.plantAddedSuccessfully);
        commonUtils.hideModalPopUp("addPlantModalClose");
      }
      setGlobalSpinner(false);
    }

    function addPlantFailure() {
      var res = plantStore.getAddPlantWebAdminResult();
      toast.error(res);
      setGlobalSpinner(false);
    }

    plantStore.addChangeListener(
      PlantConstants.ADD_PLANT_WEBADMIN_SUCCESS,
      addPlantSuccess,
    );

    plantStore.addChangeListener(
      PlantConstants.ADD_PLANT_WEBADMIN_FAILURE,
      addPlantFailure,
    );

    return () => {
      plantStore.removeChangeListener(
        PlantConstants.ADD_PLANT_WEBADMIN_SUCCESS,
        addPlantSuccess,
      );

      plantStore.removeChangeListener(
        PlantConstants.ADD_PLANT_WEBADMIN_FAILURE,
        addPlantFailure,
      );
    };
  }, []);
  /*---------------------------Add plant section end -------------------------------------------------*/

  /*---------------------------block organisation section start -------------------------------------*/
  useEffect(() => {
    function blockOrganisationSuccess() {
      var res = usermanagementStore.getBlockOrganisationResult();
      commonUtils.hideModalPopUp("blockModalClose");
      toast.success(localization.organisationBlockedSuccessfully);

      getOrganisations();
    }

    function blockOrganisationFailure() {
      var res = usermanagementStore.getBlockOrganisationResult();
      setGlobalSpinner(false);
      toast.error(res);
    }

    usermanagementStore.addChangeListener(
      UsermanagementConstants.BLOCK_ORGANISATION_SUCCESS,
      blockOrganisationSuccess,
    );

    usermanagementStore.addChangeListener(
      UsermanagementConstants.BLOCK_ORGANISATION_FAILURE,
      blockOrganisationFailure,
    );

    return () => {
      usermanagementStore.removeChangeListener(
        UsermanagementConstants.BLOCK_ORGANISATION_SUCCESS,
        blockOrganisationSuccess,
      );

      usermanagementStore.removeChangeListener(
        UsermanagementConstants.BLOCK_ORGANISATION_FAILURE,
        blockOrganisationFailure,
      );
    };
  }, []);
  /*--------------------------block organisation section end ---------------------------------------*/
  function RenderBlockUnblocButton(props) {
    const isBLocked = props.isBLocked;
    const id = props.id;
    if (isBLocked) {
      return (
        <CgUnblock
          id="unblockTest"
          className="cursorPoint svgIcon"
          title={localization.unblock}
          size={27}
          onClick={() => {
            setOrgid(id);
            unblockOrganisation(id);
          }}
        />
      );
    } else {
      return (
        <CgBlock
          id="blockTest"
          className="cursorPoint svgIcon"
          title={localization.block}
          size={30}
          onClick={() => {
            setOrgid(id);
          }}
          data-toggle="modal"
          data-target="#blockModal"
        />
      );
    }
  }

  function RenderButtons(props) {
    const list = props.list;
    return (
      <>
        <MdAddBusiness
          id="addorganisationTest"
          title={localization.addOrganisationPopUpTitle}
          className="mr-4 cursorPoint svgIcon"
          size={30}
          data-toggle="modal"
          data-target="#addOrganisationModal"
        />
        <div>
          <MdPersonAdd
            id="addorganisationadminTest"
            className="cursorPoint svgIcon"
            title={localization.addOrganisationAdmin}
            size={30}
            onClick={() => {
              setOrganizationList(list);
            }}
            data-toggle="modal"
            data-target="#addOrganisationAdminModal"
          />

          <MdRefresh
            id="refreshOrganisationList"
            className="cursorPoint svgIcon ml-3"
            title={localization.refresh || "Refresh"}
            size={27}
            onClick={() => {
              getOrganisations();
            }}
          />
        </div>
      </>
    );
  }

  function RenderAddPlantButton(props) {
    const id = props.orgId;
    const name = props.organisationName;
    return (
      <>
        <MdAddLocationAlt
          id="addNewPlantTest"
          className="cursorPoint svgIcon ml-3"
          title={localization.addnewplant}
          size={27}
          onClick={() => {
            setOrgid(id);
            setOrgName(name);
          }}
          data-toggle="modal"
          data-target="#addPlantModal"
        />
      </>
    );
  }

  /*--------------------------Add Data organisation section Start ---------------------------------------*/
  useEffect(() => {
    function addOrgDataSuccess() {
      var res = organisationSettingStore.getAddDemoDataResult();
      if (res) {
        toast.success(localization.addedSuccess);
      }
      setGlobalSpinner(false);
    }

    function addOrgDataFailure() {
      var res = organisationSettingStore.getAddDemoDataResult();
      if (res) {
        toast.error(res);
      }
      setGlobalSpinner(false);
    }

    organisationSettingStore.addChangeListener(
      organisationSettingConstants.ADD_ORG_DATA_SETTING_SUCCESS,
      addOrgDataSuccess,
    );

    organisationSettingStore.addChangeListener(
      organisationSettingConstants.ADD_ORG_DATA_SETTING_FAILURE,
      addOrgDataFailure,
    );

    return () => {
      organisationSettingStore.removeChangeListener(
        organisationSettingConstants.ADD_ORG_DATA_SETTING_SUCCESS,
        addOrgDataSuccess,
      );

      organisationSettingStore.removeChangeListener(
        organisationSettingConstants.ADD_ORG_DATA_SETTING_FAILURE,
        addOrgDataFailure,
      );
    };
  }, []);

  function RenderAddDataButton(props) {
    const id = props.orgId;

    return (
      <>
        <MdAddCircleOutline
          id="addDataTest"
          className="cursorPoint svgIcon ml-3"
          title={localization.addData}
          size={27}
          onClick={() => {
            setGlobalSpinner(true);
            OrganisationSettingActions.addDataOrg(id);
          }}
        />
      </>
    );
  }

  /*--------------------------Add Data organisation section End ---------------------------------------*/

  /*-------------------------- Partial Data Delete organisation section Start ---------------------------------------*/
  useEffect(() => {
    function partialDelSuccess() {
      var res = organisationSettingStore.getPartialDelResult();
      if (res) {
        toast.success(localization.delSuccess);
      }
      setGlobalSpinner(false);
    }

    function partialDelFailure() {
      var res = organisationSettingStore.getPartialDelResult();
      if (res) {
        toast.error(res);
      }
      setGlobalSpinner(false);
    }

    organisationSettingStore.addChangeListener(
      organisationSettingConstants.PARITAL_DEL_ORG_SETTING_SUCCESS,
      partialDelSuccess,
    );

    organisationSettingStore.addChangeListener(
      organisationSettingConstants.PARITAL_DEL_ORG_SETTING_FAILURE,
      partialDelFailure,
    );

    return () => {
      organisationSettingStore.removeChangeListener(
        organisationSettingConstants.PARITAL_DEL_ORG_SETTING_SUCCESS,
        partialDelSuccess,
      );

      organisationSettingStore.removeChangeListener(
        organisationSettingConstants.PARITAL_DEL_ORG_SETTING_FAILURE,
        partialDelFailure,
      );
    };
  }, []);

  function RenderParitalDelButton(props) {
    const id = props.orgId;

    return (
      <>
        <MdDeleteOutline
          id="paritalDelTest"
          className="cursorPoint ml-3 svgOrgDelIcon"
          title={localization.partialDelete}
          size={27}
          onClick={() => {
            deleteConfirmation(
              id,
              localization.confirmationParDel,
              "PARITAL_DEL",
            );
          }}
        />
      </>
    );
  }

  /*-------------------------- Partial Data Delete organisation section End---------------------------------------*/

  /*-------------------------- Complete Data Delete organisation section Start---------------------------------------*/
  useEffect(() => {
    function fullDelSuccess() {
      var res = organisationSettingStore.getfullDelResult();
      if (res) {
        toast.success(localization.delSuccess);
      }
      setGlobalSpinner(false);
    }

    function fullDelFailure() {
      var res = organisationSettingStore.getfullDelResult();
      if (res) {
        toast.error(res);
      }
      setGlobalSpinner(false);
    }

    organisationSettingStore.addChangeListener(
      organisationSettingConstants.FULL_DEL_ORG_SETTING_SUCCESS,
      fullDelSuccess,
    );

    organisationSettingStore.addChangeListener(
      organisationSettingConstants.FULL_DEL_ORG_SETTING_FAILURE,
      fullDelFailure,
    );

    return () => {
      organisationSettingStore.removeChangeListener(
        organisationSettingConstants.FULL_DEL_ORG_SETTING_SUCCESS,
        fullDelSuccess,
      );

      organisationSettingStore.removeChangeListener(
        organisationSettingConstants.FULL_DEL_ORG_SETTING_FAILURE,
        fullDelFailure,
      );
    };
  }, []);

  function RenderFullDelButton(props) {
    const id = props.orgId;

    return (
      <>
        <MdDelete
          id="deleteTest"
          className="cursorPoint ml-3 svgOrgDelIcon "
          title={localization.delete}
          size={27}
          onClick={() => {
            deleteConfirmation(
              id,
              localization.confirmationFullDel,
              "FULL_DEL",
            );
          }}
        />
      </>
    );
  }

  /*-------------------------- Complete Data Delete organisation section End---------------------------------------*/

  /*---------------------------Clone organisation section start ----------------------------------------------------*/
  function RenderCloneButton(props) {
    const id = props.orgId;
    const name = props.organisationName;
    return (
      <>
        <FaRegClone
          id="cloneOrgTest"
          className="cursorPoint svgIcon ml-3"
          title={localization.cloneOrg}
          size={20}
          onClick={() => {
            setOrgid(id);
            setOrgName(name);
          }}
          data-toggle="modal"
          data-target="#cloneOrganisationModal"
        />
      </>
    );
  }

  function RenderExportButton(props) {
    const id = props.orgId;
    return (
      <>
        <BiExport
          id="ExportOrgDataTest"
          className="cursorPoint svgIcon ml-3"
          title={localization.exportOrgData}
          size={27}
          onClick={() => {
            UserManagementActions.exportOrganisationData(id);
            toast.success(localization.organisationDataPreparedForDownload);
            setTimeout(() => {
              getOrganisations();
            }, 5000);
          }}
        />
      </>
    );
  }

  const handleOrgDataExportDownload = useCallback((exportData) => {
    if (exportData !== null && exportData !== undefined) {
      const url = window.URL.createObjectURL(exportData);
      let a = document.createElement("a");
      let name =
        "Organisation_" +
        currentExportOrgName.current +
        "_" +
        dateFormat(Date(), "yyyy-mm-dd_hh-mm-ss") +
        ".zip";
      a.hidden = "";
      a.href = url;
      a.download = name;
      a.click();
      setGlobalSpinner(false);
      // Clear the ref after download
      currentExportOrgName.current = "";
    }

    return () => {};
  }, []);

  useEffect(() => {
    function exportOrganisationDataSuccess() {
      var res = usermanagementStore.getExportOrganisationDataResult();
    }

    function exportOrganisationDataFailure() {
      var res = usermanagementStore.getExportOrganisationDataResult();
      toast.error(res);
    }

    usermanagementStore.addChangeListener(
      UsermanagementConstants.EXPORT_ORGANISATION_DATA_SUCCESS,
      exportOrganisationDataSuccess,
    );

    usermanagementStore.addChangeListener(
      UsermanagementConstants.EXPORT_ORGANISATION_DATA_FAILURE,
      exportOrganisationDataFailure,
    );

    return () => {
      usermanagementStore.removeChangeListener(
        UsermanagementConstants.EXPORT_ORGANISATION_DATA_SUCCESS,
        exportOrganisationDataSuccess,
      );

      usermanagementStore.removeChangeListener(
        UsermanagementConstants.EXPORT_ORGANISATION_DATA_FAILURE,
        exportOrganisationDataFailure,
      );
    };
  }, []);

  function RenderDownloadButton(props) {
    const id = props.orgId;
    const name = props.organisationName;
    return (
      <>
        <MdDownloadForOffline
          id="DownloadOrgDataTest"
          className="cursorPoint svgIcon ml-3"
          title={localization.downloadOrgData}
          size={27}
          onClick={() => {
            currentExportOrgName.current = name; // Store name in ref
            setGlobalSpinner(true);
            UserManagementActions.downloadOrganisationData(id);
          }}
        />
      </>
    );
  }

  useEffect(() => {
    function downloadOrganisationDataSuccess() {
      var res = usermanagementStore.getDownloadOrganisationDataResult();
      handleOrgDataExportDownload(res);
      toast.success(localization.orgDataExportSuccess);
      setGlobalSpinner(false);
    }

    function downloadOrganisationDataFailure() {
      var res = usermanagementStore.getDownloadOrganisationDataResult();
      setGlobalSpinner(false);
      toast.error(res);
    }

    usermanagementStore.addChangeListener(
      UsermanagementConstants.DOWNLOAD_ORGANISATION_DATA_SUCCESS,
      downloadOrganisationDataSuccess,
    );

    usermanagementStore.addChangeListener(
      UsermanagementConstants.DOWNLOAD_ORGANISATION_DATA_FAILURE,
      downloadOrganisationDataFailure,
    );

    return () => {
      usermanagementStore.removeChangeListener(
        UsermanagementConstants.DOWNLOAD_ORGANISATION_DATA_SUCCESS,
        downloadOrganisationDataSuccess,
      );

      usermanagementStore.removeChangeListener(
        UsermanagementConstants.DOWNLOAD_ORGANISATION_DATA_FAILURE,
        downloadOrganisationDataFailure,
      );
    };
  }, []);

  const cloneOrganisationSuccessCallback = () => {
    getOrganisations();
  };
  /*---------------------------Clone organisation section end ------------------------------------------------------*/

  /*-------------------------- Confirmation message Start---------------------------------------*/
  function deleteConfirmation(id, message, delteKey) {
    setConfirmationPopUpOpen(true);
    setConfirmationPopUpMsg(message);
    setCallbackData({
      org: id,
    });
    setEventType(delteKey);
  }

  const closePopUpCallback = () => {
    setConfirmationPopUpOpen(false);
    setConfirmationPopUpMsg("");
    setCallbackData(null);
    setEventType(null);
  };

  const closeEditPlantPopUpCallback = () => {};
  const confirmationOkCancelCallback = (isConfirmed, eventType, data) => {
    if (isConfirmed) {
      switch (eventType) {
        case "FULL_DEL":
          setGlobalSpinner(true);
          const res = OrganisationSettingActions.fullDelOrg(data.org);
          closePopUpCallback();
          break;
        case "PARITAL_DEL":
          setGlobalSpinner(true);
          const response = OrganisationSettingActions.partialDelOrg(data.org);
          closePopUpCallback();
          break;
        default:
          break;
      }
    } else {
      closePopUpCallback();
    }
  };
  /*-------------------------- Confirmation message End---------------------------------------*/
  return (
    <>
      <div style={{ height: "100%", width: "100%", overflow: "auto" }}>
        <div className="container"></div>

        <div className="container pt-4 pb-4 d-flex justify-content-between">
          <RenderButtons list={organisationsList} />
        </div>

        <div className="container table-responsive tableHeight">
          <table className="table table-striped table-hover table-sticky">
            <thead className="bg-light">
              <tr>
                <th>{localization.organisation}</th>
                <th>{localization.blocked}</th>
                <th>{localization.reason}</th>
                <th>{localization.lastExportDate}</th>
                <th style={{ zIndex: 1 }}>{localization.action}</th>
              </tr>
            </thead>
            <tbody>
              {organisationsList.map((row, index) => {
                return (
                  <tr key={index}>
                    <td>
                      <div className="d-flex align-items-center">
                        <div className="ms-3">
                          <p className="fw-bold mb-1">{row.name}</p>
                        </div>
                      </div>
                    </td>
                    <td>
                      <p className="fw-normal mb-1">
                        {row.isBlocked ? localization.yes : localization.no}
                      </p>
                    </td>
                    <td>
                      <p className="fw-normal mb-1">{row.blockingReason} </p>
                    </td>
                    <td>
                      <p className="fw-normal mb-1">{row.exportDate} </p>
                    </td>
                    <td>
                      <div className="d-flex">
                        <RenderBlockUnblocButton
                          isBLocked={row.isBlocked}
                          id={row.id}
                        />
                        <RenderAddPlantButton
                          orgId={row.id}
                          organisationName={row.name}
                        />
                        <RenderAddDataButton orgId={row.id} />
                        <RenderParitalDelButton orgId={row.id} />
                        <RenderFullDelButton orgId={row.id} />
                        {!row.isProduction && (
                          <RenderCloneButton
                            orgId={row.id}
                            organisationName={row.name}
                          />
                        )}
                        {row.exportStatus !== "Exporting" && (
                          <RenderExportButton
                            orgId={row.id}
                            organisationName={row.name}
                          />
                        )}

                        {row.exportStatus === "Exported" && (
                          <RenderDownloadButton
                            orgId={row.id}
                            organisationName={row.name}
                          />
                        )}
                        {row.exportStatus === "Exporting" && (
                          <CircularProgress
                            size={25}
                            title={localization.exportingData}
                            className="ml-3"
                          />
                        )}
                        {row.exportStatus === "Failed" && (
                          <MdError
                            title={localization.exportFailed}
                            size={27}
                            color="red"
                          />
                        )}
                      </div>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
      <BlockOrganisation orgid={orgid} />
      <AddOrganizations />
      <AddOrganizationAdmin orgList={organisationsList} />
      <AddPlant
        orgid={orgid}
        organisationName={orgname}
        closeEditPlantPopUpCallback={closeEditPlantPopUpCallback}
        isWebsiteAdmin={isWebsiteAdmin}
      />
      <CloneOrganisation
        orgid={orgid}
        organisationName={orgname}
        cloneOrganisationSuccessCallback={cloneOrganisationSuccessCallback}
      />
      <ConfirmationPopUp
        isOpen={confirmationPopUpOpen}
        okCancelCallback={confirmationOkCancelCallback}
        close={closePopUpCallback}
        title=""
        msg={confirmationPopUpMsg}
        eventType={eventType}
        callbackData={callbackData}
      />
    </>
  );
};

export default OrganizationsAdmin;
